<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-11 16:04:08
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-12 17:58:04
 * @FilePath: \hzs-nutra-wecom-shop\src\views\live\liveDetail\components\liveDetailData.vue
 * @Description: 直播详情 - 明细数据
-->

<template>
  <div class="activity_detail_data h100">
    <!-- 统计数据 -->
    <div class="dataBox" :class="state.toggleShowData ? 'active' : ''">
      <div class="dataInner">
        <div class="data_li">
          <span class="data_li_label">实际观看人数：</span>
          <div class="data_li_val">
            {{ state.activity?.view_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">累计评论数：</span>
          <div class="data_li_val">
            {{ state.activity?.message_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">实际点赞数：</span>
          <div class="data_li_val">
            {{ state.activity?.liked_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">全部达标人数：</span>
          <div class="data_li_val">
            {{ state.activity?.all_satisfy_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">全部未达标人数：</span>
          <div class="data_li_val">
            {{ state.activity?.all_not_satisfy_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">时长达标人数：</span>
          <div class="data_li_val">
            {{ state.activity?.watch_time_satisfy_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">签到达标人数：</span>
          <div class="data_li_val">
            {{ state.activity?.sign_satisfy_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">问答达标人数：</span>
          <div class="data_li_val">
            {{ state.activity?.question_satisfy_num || 0 }}
          </div>
        </div>
        <div class="data_li">
          <span class="data_li_label">累计发放积分：</span>
          <div class="data_li_val">
            {{
              state.activity?.total_satisfy_point
                ? state.activity?.total_satisfy_point + "分"
                : 0
            }}
          </div>
        </div>
      </div>

      <!-- <div
        class="toggleShowQuestion flex align-center justify-center"
        @click="handleToggleShowData"
      >
        <div class="iconBox" :class="toggleShowData ? 'active' : ''">
          <van-icon
            v-if="state.toggleShowData"
            name="arrow-down"
            color="#F16023"
            size="16px"
          />
          <van-icon v-else name="arrow-up" color="#F16023" size="16px" />
        </div>
        <div class="text">
          {{ state.toggleShowData ? "收起" : "展开" }}
        </div>
      </div> -->
    </div>

    <!-- 搜索框 -->
    <div class="searchBox flex align-center justify-sb">
      <van-icon name="search" color="#B3B3B3" size="24" />

      <input
        type="text"
        v-model="state.queryName"
        class="flex-1"
        placeholder="请输入客户名称或手机号搜索"
      />
    </div>

    <!-- 列表 -->
    <div class="activity_list_box flex">
      <scroll-view
        v-if="state.list.length !== 0"
        scroll-y
        class="scroll-content flex-1"
        scroll-top="{{0}}"
        bindscrolltolower="onReachBottom"
      >
        <template v-for="item in state.list" :key="item.id">
          <div
            class="activity_li"
            data-item="{{item}}"
            catchtap="gotoDetailPage"
          >
            <div class="nickName">昵称：{{ item.name }}</div>

            <div class="flex justify-between align-center">
              <div class="activity_li_label">观看时长</div>
              <div class="activity_li_value">{{ item.watch_time }}</div>
            </div>

            <div class="flex justify-between align-center">
              <div class="activity_li_label">是否时长达标</div>
              <div
                class="activity_li_value {{item.watch_time_satisfy?'yes':'no'}}"
              >
                {{ item.watch_time_satisfy ? "是" : "否" }}
              </div>
            </div>

            <div
              v-if="state.activity?.sign == 1"
              class="flex justify-between align-center"
            >
              <div class="activity_li_label">是否签到达标</div>
              <div class="activity_li_value {{item.sign_satisfy?'yes':'no'}}">
                {{ item.sign_satisfy ? "是" : "否" }}
              </div>
            </div>

            <div
              v-if="state.activity?.question == 1"
              class="flex justify-between align-center"
            >
              <div class="activity_li_label">是否问答达标</div>
              <div
                class="activity_li_value {{item.question_satisfy?'yes':'no'}}"
              >
                {{ item.question_satisfy ? "是" : "否" }}
              </div>
            </div>
          </div>
        </template>
      </scroll-view>
      <van-empty
        v-if="state.list.length === 0"
        class="pct100"
        :image="EmptyLive"
        :description="`暂无数据`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import EmptyLive from "@/assets/img/live/emptyLive.png";

const state = reactive({
  imgHeaderUrl: "",
  userInfo: "",
  liveId: "", // 直播id
  activity: {},

  currentDate: new Date().getTime(),
  minDate: new Date().getTime(),
  maxDate: new Date().getTime(),

  list: [],
  page: 1,
  pageSize: 10,
  total: 0,

  param: "",

  live_tag_name: [], // 标签
  toggleShowData: false,
});

onMounted(() => {
  // setMinMaxDate();
  // loginOnce();
  // handleSearch()
});

// function loginOnce () {
//   let that = this;
//   const afterLogin = async () => {
//     const userInfo = app.globalData.userInfo;
//     that.setData({
//       userInfo
//     });
//     that.getInfoData();
//     cb && cb();
//   }
//   app.getLoginInfo({}, () => {
//     afterLogin()
//   });
// }
// async function getInfoData() {
//   wx.showLoading({
//     title: '加载中',
//     mask: true,
//   });
//   let newData = await this.apiGetLiveDetail();
//   wx.hideLoading();
//   if (newData.code !== 200) {
//     wx.showToast({
//       title: newData.msg || "请求失败，请重试？",
//       icon: "none"
//     });
//     return false;
//   }
//   let data = newData.data.live_info;
//
//   console.log('');
//   console.log(data);
//
//   if (data.uuid) {
//     let {
//       statusVal,
//       statusCls,
//       status
//     } = this.setLiveStatus(data.status);
//     data.start_time_s = moment(data.start_time).format('YYYY/MM/DD HH:mm');
//     data.end_time_s = moment(data.end_time).format('YYYY/MM/DD HH:mm');
//     data.start_time = moment(data.start_time).format('YYYY/MM/DD HH:mm');
//     data.end_time = moment(data.end_time).format('YYYY/MM/DD HH:mm');
//
//     data.statusVal = statusVal;
//     data.statusCls = statusCls;
//     data.status = status;
//
//     data.watchTime = data.watch_time ? this.setWatchTime(data.watch_time) : '';
//   }
//   this.setData({
//     activity: data,
//     push_link: newData.data.push_link, // 推流地址
//   });
//   if (newData.data.auth_token?.length) {
//     let auth_token = [];
//     newData.data.auth_token.forEach((item) => {
//       auth_token.push(Object.values(item));
//     });
//     this.setData({
//       auth_token
//     });
//   }
// }

// // 获取3年前时间
// function setMinMaxDate () {
//   const today = new Date();
//   this.setData({
//     minDate: new Date().getTime() + (24 * 60 * 60 * 1000), //
//     maxDate: new Date().getTime() + (7 * 24 * 60 * 60 * 1000) // 一周后的时间
//   });
// }
// // function getLiveTime(startTime, endTime) {
// //     let startTime_n = new Date(startTime).getTime();
// //     let endTime_n = new Date(endTime).getTime();
// //     return (endTime_n - startTime_n) / (60 * 1000);
// // },
//  function setWatchTime(time) {
//   return time === 0 ? 0 : util.convertSecondsToHMS(time);
// }

// /**
//  * 页面上拉触底事件的处理函数
//  */
// async function onReachBottom () {
//   // console.log('页面上拉触底事件的处理函数');
//
//   if (this.data.list.length >= this.data.total) return;
//
//   let page = this.data.page + 1;
//   this.setData({
//     page
//   });
//
//   this.getList()
// }
// function setLiveStatus(status) {
//   let statusVal = "";
//   let statusCls = "";
//   if (status === 1) {
//     statusVal = "待开播";
//     statusCls = "status_await";
//   } else if (status === 20) {
//     statusVal = "直播中";
//     statusCls = "status_underway";
//   } else if (status === 30) {
//     statusVal = "已结束";
//     statusCls = "status_end";
//   } else {
//     statusVal = "已取消";
//     statusCls = "status_cancel";
//   }
//   return {
//     statusVal,
//     statusCls,
//     status,
//   }
// }

// // 输入事件
// function bindInput(e) {
//   let {
//     name,
//   } = e.currentTarget.dataset;
//
//   this.setData({
//     [name]: e.detail.value
//   });
// }
// async function handleSearch() {
//   this.setData({
//     page: 1
//   });
//
//   this.getList()
// }
// async function getList() {
//   let res = await this.getUser()
//
//   if (res?.code === 200) {
//     let tempList = (res?.data || [])?.map(v => ({
//       ...v,
//       watch_time: util.convertSecondsToHMS(v.watch_time)
//     }))
//
//     let list = this.data.list
//     if (this.data.page == 1) {
//       list = tempList
//     } else {
//       list.push(...tempList)
//     }
//
//     this.setData({
//       list,
//       total: res.cnt
//     })
//   }
// }

// function handleToggleShowData() {
//   this.setData({
//     toggleShowData: !this.data.toggleShowData
//   })
// }

// ----------------------------------------------- 接口
// function apiGetLiveDetail() {
//   let userInfo = app.globalData.userInfo;
//   let req = {
//     shop_uuid: userInfo.shop_uuid,
//     uuid: this.data.liveId,
//   };
//   return new Promise((resolve, reject) => {
//     api.getLiveDetail(req, (res) => {
//       resolve(res)
//     });
//   })
// }
// function getUser() {
//   let userInfo = app.globalData.userInfo;
//   let req = {
//     live_uuid: this.data.liveId,
//     nick_name_or_phone: this.data.param,
//     firm_uuid: userInfo.firm_uuid,
//     page: this.data.page,
//     page_size: this.data.pageSize,
//   };
//   return new Promise((resolve, reject) => {
//     api.ownLiveDetailUser(req, (res) => {
//       resolve(res)
//     })
//   });
// }
</script>

<style lang="scss">
.mb-20 {
  margin-bottom: 20rpx;
}

.activity_detail_data {
  height: calc(100% - 48rpx);
  padding: 24rpx 40rpx;

  // =========================
  // 1. 数据详情卡片 (Data Box)
  // =========================
  .dataBox {
    padding: 14px 16px 18px;
    background: #ffffff;
    border-radius: 23rpx 23rpx 23rpx 23rpx;

    .dataInner {
      height: 110rpx;
      overflow: hidden;
      transition: height linear 0.3s;
      -webkit-transition: height linear 0.3s;
      -moz-transition: height linear 0.3s;
      -o-transition: height linear 0.3s;

      // =========================
      // 1.2. 数据列表项 (Data List)
      // =========================
      .data_li {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:not(:first-child) {
          margin-top: 14px;
        }

        height: 22px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        .data_li_label {
          color: #666666;
        }

        .data_li_val {
          color: #333333;
        }
      }
    }

    // &.active {
    //   .dataInner {
    //     height: 586rpx;
    //   }
    // }
    // .toggleShowQuestion {
    //   margin-top: 15rpx;
    //
    //   .text {
    //     height: 38rpx;
    //     font-family:
    //       PingFang SC,
    //       PingFang SC;
    //     font-weight: 400;
    //     font-size: 27rpx;
    //     color: #f16023;
    //     text-align: left;
    //     font-style: normal;
    //     text-transform: none;
    //   }
    //
    //   .iconBox {
    //     transform: rotate(180deg);
    //     -ms-transform: rotate(180deg);
    //     -moz-transform: rotate(180deg);
    //     -webkit-transform: rotate(180deg);
    //     -o-transform: rotate(180deg);
    //
    //     &.active {
    //       transition: transform linear 0.3s;
    //       -webkit-transition: transform linear 0.3s;
    //       -moz-transition: transform linear 0.3s;
    //       -o-transition: transform linear 0.3s;
    //     }
    //   }
    // }
  }

  // =========================
  // 3. 搜索框 (Search Box)
  // =========================
  .searchBox {
    height: 45px;
    padding: 11px;
    margin: 10px auto;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;

    input {
      flex: 1;
      width: calc(100% - 24px - 8px);
      height: 100%;
      border: none;
      outline: none;

      color: #999;
      font-weight: 400;
      font-size: 14px;
    }
    /* WebKit browsers */
    input::-webkit-input-placeholder,
    textarea::-webkit-input-placeholder {
      color: #999;
      font-weight: 400;
      font-size: 14px;
    }
    /* Mozilla Firefox 4 to 18 */
    input:-moz-placeholder,
    textarea:-moz-placeholder {
      color: #999;
      font-weight: 400;
      font-size: 14px;
    }
    /* Mozilla Firefox 19+ */
    input::-moz-placeholder,
    textarea::-moz-placeholder {
      color: #999;
      font-weight: 400;
      font-size: 14px;
    }
    /* Internet Explorer 10+ */
    input:-ms-input-placeholder,
    textarea:-ms-input-placeholder {
      color: #999;
      font-weight: 400;
      font-size: 14px;
    }
  }

  // =========================
  // 4. 活动列表 (Activity List)
  // =========================
  .activity_list_box {
    height: calc(100% - (112rpx + 20rpx) - (110rpx + 42rpx + 15rpx + 48rpx));

    .scroll-content {
      overflow-y: scroll;
    }

    .activity_li {
      padding: 24rpx;
      margin-top: 20rpx;
      background: #ffffff;
      border-radius: 23rpx 23rpx 23rpx 23rpx;

      .flex {
        margin-top: 19rpx;
      }

      .nickName {
        height: 42rpx;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 500;
        font-size: 31rpx;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .activity_li_label {
        height: 42rpx;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 31rpx;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .activity_li_value {
        height: 42rpx;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 31rpx;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;

        &.yes {
          color: #41b55c;
        }

        &.no {
          color: #ff0000;
        }
      }
    }
  }
}

// =========================
// 5. 全局联动逻辑 (Sibling Selector)
// =========================
// 注意：由于使用了 ~ 兄弟选择器，且 .activity_list_box 已在上面定义过基础样式
// 这里单独列出状态变更样式，保持逻辑清晰
.dataBox.active ~ .activity_list_box {
  height: calc(100% - (112rpx + 20rpx) - (586rpx + 42rpx + 15rpx + 48rpx));
}
</style>
